import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
export default function DurationCell({
  goalTarget
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "goal-milestone",
      message: `goals-reporting-lib.table.milestone.values.${goalTarget.milestone}`
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(Small, {
        use: "help",
        children: [goalTarget.startDatetime ? /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "L",
          type: "utc",
          value: goalTarget.startDatetime
        }) : /*#__PURE__*/_jsx(NoDate, {}), ' - ', goalTarget.endDatetime ? /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "L",
          type: "utc",
          value: goalTarget.endDatetime
        }) : /*#__PURE__*/_jsx(NoDate, {}), /*#__PURE__*/_jsx("div", {
          children: goalTarget.fiscalYearOffset !== 0 && /*#__PURE__*/_jsx(FormattedMessage, {
            message: `goals-reporting-lib.table.subtext.fiscalYearGoal`
          })
        })]
      })
    })]
  });
}

function NoDate() {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `goals-reporting-lib.table.subtext.invalidDate`
  });
}